import { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ApplicationContext } from '../../context/GlobalState';
import { extractLocaleFromPath, t } from '../../i18n';
import { FaSignature, FaArrowRight, FaTimes } from 'react-icons/fa';
import './NewPatientPaperworkBanner.css';

const STORAGE_KEY = 'npp_banner_dismissed_v1';

export default function NewPatientPaperworkBanner() {
  const { state } = useContext(ApplicationContext);
  const location = useLocation();
  const { locale } = extractLocaleFromPath(location.pathname);
  const prefix = locale === 'en' ? '' : `/${locale}`;

  const [dismissed, setDismissed] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (_) {
      return false;
    }
  });
  if (dismissed) return null;

  // Per-brand English ThorDocs intake target. GSO uses the default (Georgia) doc;
  // Apex NC/TN deep-link to their state-specific English paperwork.
  const brandKey = state?.brand?.brandKey || 'gso';
  const BRAND_PAPERWORK_PATH = {
    gso: '/new-patient-paperwork',
    'apex-nc': '/new-patient-paperwork/nc',
    'apex-tn': '/new-patient-paperwork/tn',
  };
  const paperworkPath = BRAND_PAPERWORK_PATH[brandKey] || BRAND_PAPERWORK_PATH.gso;

  const handleClose = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (_) {}
    // State-driven dismiss (2026-07-21 audit L5): the old direct-DOM hide was
    // resurrected by any re-render, and a localStorage failure never persisted.
    setDismissed(true);
  };

  return (
    <div className="npp-banner" role="region" aria-label={t('paperwork.notice', locale)}>
      <div className="npp-banner__inner">
        <span className="npp-banner__icon" aria-hidden="true">
          <FaSignature />
        </span>
        <div className="npp-banner__copy">
          <strong>{t('paperwork.newPatient', locale)}</strong>
          <span> {t('paperwork.bannerDesc', locale)}</span>
        </div>
        <Link to={`${prefix}${paperworkPath}`} className="npp-banner__cta">
          {t('paperwork.sign', locale)} <FaArrowRight size={11} />
        </Link>
        <button
          type="button"
          className="npp-banner__close"
          aria-label={t('paperwork.dismiss', locale)}
          onClick={handleClose}
        >
          <FaTimes size={12} />
        </button>
      </div>
    </div>
  );
}
